import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "@/components/Select";
import {
    useNavigationMode,
    type NavigationMode,
} from "@/components/workspace/useNavigationMode";

interface NavigationAppearanceProps {
    embedded?: boolean;
}

export const NavigationAppearance = ({
    embedded = false,
}: NavigationAppearanceProps) => {
    const { t } = useTranslation("global");
    const id = useId();
    const [mode, setMode] = useNavigationMode();
    return (
        <section
            aria-labelledby={id}
            className={
                embedded ? "space-y-4 p-6 sm:p-8" : "box space-y-4 p-6 sm:p-8"
            }
        >
            <div className="text-center">
                <h2 id={id} className="box-title">
                    {t("workspace.navigation")}
                </h2>
                <p className="box-subtitle">
                    {t("workspace.navigation_description")}
                </p>
            </div>
            <Select<NavigationMode>
                label={t("workspace.navigation_layout")}
                value={mode}
                onChange={setMode}
                full
                options={[
                    {
                        value: "topbar",
                        label: t("workspace.navigation_topbar"),
                    },
                    {
                        value: "sidebar",
                        label: t("workspace.navigation_sidebar"),
                    },
                ]}
            />
            <p className="text-xs text-slate-600 dark:text-zinc-300">
                {t("workspace.navigation_hint")}
            </p>
        </section>
    );
};
